import { isEmpty } from '../../../utils'
// eslint-disable-next-line no-useless-escape
const P_REG = /[\u4e00-\u9fa5a-z_A-Z!@#\$%\\\^&\*\)\(\+=\{\}\[\]\/",'<>~\`\?:;|]+$/g
const REGEXP = /[^\-\d^\\.]+/g

// 处理当前值 - 情况
export const getPercentageValue = (value) => {
  return value.replace(P_REG, '').replace(/\s*/g, '').replace(REGEXP, '').replace('/\s/g', '').replace(/-/g, (_, index) => index === 0 ? '-' : '')
}

export const percentageProps = {
  value: {
    type: [String, Number]
  },
  placeholder: {
    type: String,
    default: ''
  },
  // 组件大小
  size: {
    type: String,
    default: 'small'
  },
  // 纯文本
  isPureText: {
    type: Boolean,
    default: true
  },
  disabled: {
    type: Boolean,
    default: false
  },
  // 值是否在百分位上 百分数是否需要换算 除以100
  percentileValue: {
    type: Boolean,
    default: false
  }
}

export const initValue = (value) => {
  return isEmpty(value) ? '-' : (value + '%')
}